import {
  jb_news_overlay_css_default
} from "./chunk.XSH5KLLN.js";
import {
  JbOverlay
} from "./chunk.75HJXTVU.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.27HF5Y4Z.js";
import {
  parseHashToObject,
  recenterNavItems
} from "./chunk.NKAUZW5M.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-news-overlay/jb-news-overlay.ts
var JbNewsOverlay = class extends Animatable(Initiable(r)) {
  constructor() {
    super(...arguments);
    this._responseHtml = "";
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("keyup", (evt) => {
      if (evt.key === "Escape") {
        this.dispatchEvent(
          new CustomEvent("jb-overlay:close", {
            bubbles: true,
            composed: true
          })
        );
      }
    });
  }
  decodeHtml(htmlString) {
    const txt = document.createElement("textarea");
    txt.innerHTML = htmlString;
    return txt.value;
  }
  fetchDataFromApi(url) {
    import("../components/jb-audio-player/jb-audio-player.js").then();
    import("../components/jb-gallery/jb-gallery.js").then();
    import("../components/jb-image/jb-image.js").then();
    import("../components/jb-info-block/jb-info-block.js").then();
    import("../components/jb-listing/jb-listing.js").then();
    import("../components/jb-news-page-hero/jb-news-page-hero.js").then();
    import("../components/jb-publication-download/jb-publication-download.js").then();
    import("../components/jb-quote/jb-quote.js").then();
    import("../components/jb-text-with-image/jb-text-with-image.js").then();
    import("../components/jb-video/jb-video.js").then();
    fetch(url).then((response) => response.json()).then((data) => {
      this._responseHtml = data.html;
    });
  }
  firstUpdated() {
    this.fetchDataFromApi(this.url);
    this.dispatchEvent(
      new CustomEvent("jb-stackable:register-outro-callback", {
        bubbles: true,
        composed: true,
        detail: {
          callback: async () => {
            window.history.replaceState("", "", window.location.pathname + window.location.search);
          }
        }
      })
    );
  }
  render() {
    return ke`<div class="news-overlay">${ae(this.decodeHtml(this._responseHtml))}</div>`;
  }
};
JbNewsOverlay.styles = [reset_css_default, jb_news_overlay_css_default];
__decorateClass([
  n()
], JbNewsOverlay.prototype, "url", 2);
__decorateClass([
  r2()
], JbNewsOverlay.prototype, "_responseHtml", 2);
JbNewsOverlay = __decorateClass([
  customElement("jb-news-overlay")
], JbNewsOverlay);
bindEvents();

// src/components/jb-news-overlay/jb-news-overlay-controller.ts
var newsLinksRegister = {};
var JbNewsOverlayController = class {
  constructor() {
    this.overlay = void 0;
  }
  async close() {
    if (this.overlay) {
      const animatedElement = document.querySelector("jb-news-overlay");
      animatedElement.contentChildren = Array.from(animatedElement.shadowRoot.querySelectorAll("div.news-overlay"));
      await animatedElement.hide();
      this.overlay.unstack();
      enableBodyScroll(animatedElement);
      recenterNavItems();
    }
    this.overlay = void 0;
  }
  handleHashChange(target) {
    const { hash } = window.location;
    const cleanHash = hash.startsWith("#") ? hash.substring(1) : hash;
    const hashParams = parseHashToObject(cleanHash);
    if (!hash || !hashParams.overlayNews) {
      this.close();
      return;
    }
    const translationId = Number(hashParams.overlayNews);
    if (!newsLinksRegister[translationId]) {
      this.close();
      return;
    }
    const url = newsLinksRegister[translationId];
    const jbNewsOverlay = new JbNewsOverlay().init({
      props: { url }
    });
    this.overlay = new JbOverlay().init({
      props: {
        color: "gray",
        hasLogo: true,
        hasCloseIcon: true,
        svgLogo: this.svgLogo,
        newAnimation: true,
        returnFocusTo: target,
        ariaLabels: {
          label: hashParams.overlayLabel ?? void 0,
          close: hashParams.overlayClose ?? void 0
        }
      },
      childNodes: [jbNewsOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-news-overlay").then(async () => {
        setTimeout(() => {
          jbNewsOverlay.contentChildren = Array.from(jbNewsOverlay.shadowRoot.querySelectorAll("div.news-overlay"));
        }, 0);
        disableBodyScroll(jbNewsOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await jbNewsOverlay.reveal();
      });
    }
  }
  open(event) {
    const customEvent = event;
    if (!customEvent.detail.newsOverlay) {
      return;
    }
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.preventDefault();
    customEvent.detail.clickEvent.stopPropagation();
    const baseUrl = window.location.href.split("#")[0];
    let newUrl = `${baseUrl}#overlayNews=${customEvent.detail.newsOverlay.id}`;
    if (customEvent.detail.overlayAriaLabels?.label) {
      newUrl += `&overlayLabel=${customEvent.detail.overlayAriaLabels.label}`;
    }
    if (customEvent.detail.overlayAriaLabels?.close) {
      newUrl += `&overlayClose=${customEvent.detail.overlayAriaLabels.close}`;
    }
    window.open(newUrl, "_self");
    this.svgLogo = customEvent.detail.svgLogo;
    this.handleHashChange(customEvent.detail.linkTag);
  }
};
var controller = new JbNewsOverlayController();
function bindEvents() {
  document.body.addEventListener("jb-overlay:close", () => {
    controller.close();
  });
  document.body.addEventListener("jb-link:initialized", (event) => {
    const customEvent = event;
    if (!customEvent.detail.newsOverlay) {
      return;
    }
    newsLinksRegister[customEvent.detail.newsOverlay.id] = customEvent.detail.newsOverlay.url;
    const hash = window.location.hash.substring(1);
    if (hash === "" || !hash.includes("overlayNews") || !hash.split("=")[1]) {
      return;
    }
    const translationId = Number(hash.split("=")[1]);
    if (translationId === customEvent.detail.newsOverlay.id) {
      controller.handleHashChange(customEvent.detail.linkTag);
    }
  });
  document.body.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
}

export {
  bindEvents,
  JbNewsOverlay
};
